<template>
    <div class="important">
        <head-top></head-top>  
        <!-- <Gx></Gx> -->
        <National></National>
        <List></List>   
    </div>
</template>

<script>
import jsonp from 'jsonp'
import HeadTop from "./headTop"
import Gx from "./gx"
import National from "./national"
import List from "./list"

export default{
    name: 'important',
    components:{
        HeadTop,
        Gx,
        National,
        List
    },
    created(){
        this.getStatistPv();
    },
    mounted(){
        document.title = "广西抗击疫情服务";
    },
    methods:{
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=https%3a%2f%2fzgapp.gxnews.com.cn%2fh5%2f%23%2fimportant&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })  
        }
    }
}
</script>

<style lang="less" scoped>
    .column-banner{
        position: relative;
        img{
            width: 100%;
        }
    }
</style>   